import React from "react";

import StyledModal from "components/Modal";
import WarningBox from "components/WarningBox";

import { useAppDispatch } from "store/hooks";

import { updateClientApiKey } from "store/features/clientApiKeySlice";

interface TokenUpdateModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const TokenUpdateModal: React.FC<TokenUpdateModalProps> = (props) => {
  const { isOpen, onClose } = props;
  const dispatch = useAppDispatch();

  const onSubmit = async () => {
    await dispatch(updateClientApiKey()).unwrap();
    onCloseModal();
  };

  const onCloseModal = () => {
    onClose();
  };

  return (
    <StyledModal
      isOpen={isOpen}
      onClose={onCloseModal}
      title="Перегенерувати Токен"
      content={
        <WarningBox
          content="Після створення нового токена старий залишатиметься активним ще 12 годин. Якщо ви хочете одразу відключити старий токен, спершу видаліть його, а потім створіть новий.
"
        />
      }
      onAction={onSubmit}
      actionBtnText="Перегенерувати"
    />
  );
};

export default TokenUpdateModal;
